"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.passwordResetRequestSchema = exports.passwordChangeRequestSchema = exports.baseAuthSchema = void 0;
var _joi = _interopRequireDefault(require("joi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const baseAuthSchema = exports.baseAuthSchema = {
  email: _joi.default.string().email({
    tlds: {
      allow: false
    }
  }).required().messages({
    "string.empty": `Email can't be an empty field`
  }),
  password: _joi.default.string().required().min(5).messages({
    "string.empty": `Password can't be an empty field`
  })
};
const passwordResetRequestSchema = exports.passwordResetRequestSchema = {
  email: _joi.default.string().email({
    tlds: {
      allow: false
    }
  }).required().messages({
    "string.base": `Please insert a valid email address`,
    "string.empty": `Please insert a valid email address`
  })
};
const passwordChangeRequestSchema = exports.passwordChangeRequestSchema = {
  newPassword: _joi.default.string().required().min(5).messages({
    "string.empty": `Please input a strong password`
  }),
  confirmPassword: _joi.default.string().required().min(5).messages({
    "string.empty": `Please make sure "confirm password" input matches your password`
  })
};